import type { IdbStoreRecord } from '#ui-shared/idb-object-store/idb-object-store';
import { IdbObjectStore } from '#ui-shared/idb-object-store/idb-object-store';
import { symbolDatabase } from '#ui-shared/symbol-cache/symbol-database';

export interface CachedSymbolRecord extends IdbStoreRecord {
  packId: string;
  symbolId: string;
  blob: Blob;
  contentType: string;
}

/**
 * IndexedDB-backed cache for symbol data. Symbols are stored as blobs in IndexedDB, which allows for efficient storage and retrieval of binary data. This cache is used to store the actual symbol images, while metadata about symbol packs is stored separately in the SymbolPackIdbCache.
 */
class SymbolIdbCache extends IdbObjectStore<CachedSymbolRecord> {
  constructor() {
    super({
      database: symbolDatabase,
      storeName: 'symbols',
      indexes: [
        { keyPath: 'packId' },
      ],
    });
  }

  deleteByPackId(packId: string): Promise<string[]> {
    return this.deleteByIndex('packId', packId);
  }

  deletePacksNotIn(validPackIds: Set<string>): Promise<string[]> {
    return this.deleteWhere(record => !validPackIds.has(record.packId));
  }
}

export const symbolIdbCache = new SymbolIdbCache();
